import { gql, useQuery } from "@apollo/client";
import { SearchSelectInput } from "components";
import lodash from "lodash";
import type { FC } from "react";

interface UserRolePickerProps {
  id: string;
  label?: string;
  filter?: {
    requiresDistrict?: boolean;
    requiresRegion?: boolean;
  };
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  multiple?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  setFieldValue: any;
  rawId?: boolean;
  position?: "top" | "bottom";
}

const GET_USER_ROLES = gql`
  query GetUserRolesSelect(
    $requiresDistrict: Boolean
    $requiresRegion: Boolean
  ) {
    userRoles: getUserRoles(
      sort: "name"
      pageSize: 0
      page: 0
      requiresDistrict: $requiresDistrict
      requiresRegion: $requiresRegion
    ) {
      _id
      code
      name
      requiresDistrict
      requiresRegion
    }
  }
`;

export const UserRolePicker: FC<UserRolePickerProps> = ({
  id,
  label,
  multiple,
  rawId,
  filter,
  ...form
}) => {
  const { loading, data } = useQuery(GET_USER_ROLES, {
    notifyOnNetworkStatusChange: false,
    variables: {
      requiresDistrict: lodash.isBoolean(filter?.requiresDistrict)
        ? filter?.requiresDistrict
        : undefined,
      requiresRegion: lodash.isBoolean(filter?.requiresRegion)
        ? filter?.requiresRegion
        : undefined,
    },
  });

  return (
    <SearchSelectInput
      id={id ?? "role"}
      label={label ?? "User Role"}
      placeholder="Select User Role"
      optionsLoading={loading}
      multiple={multiple}
      options={(data?.userRoles ?? [])?.map((userRole: any) => ({
        label: {
          title: userRole.name as string,
        },
        value: rawId ? userRole?._id : userRole,
      }))}
      {...form}
    />
  );
};

export default UserRolePicker;
